const Settings = () => {
  return <div>Settings under construction...</div>;
};

export default Settings;
